import React, {useState, useEffect} from 'react'
import {Modal, Input, Row, Col, Button, notification } from 'antd'

function ProductModalEdit(props){
    const[nombre, setNombre] = useState("");
    const[description, setDescription] = useState("");
    const[prodId, setProdId] = useState("");

    useEffect (() => { 
        setNombre(props.nameProduct);
        setDescription(props.descProduct);
        setProdId(props.idProduct); 
    }, [props.idProduct])

    const msNotification = (type, title, desc) => {
        notification[type]({
            message: title,
            description:
            desc,
        });
    };

    const handleOk = () => {
        if(prodId !== ""){
            if(nombre !== ""){
                if(description !== ""){
                                const newProduct = {
                                    prodName: nombre,
                                    prodDesc: description,
                                }
                                props.handleOkModalEdit(newProduct);
                }else{
                    msNotification('warning', 'Producto', 'La descripción del producto no debe de ser vacio.');
                }
            }else{
                msNotification('warning', 'Producto', 'El nombre del producto no debe de ser vacio.');
            }
        }else{
            msNotification('warning', 'Producto', 'El Id del producto no debe de ser vacio.');
        }
        
      };

    const handleCancel = () => {
        props.handleCancelModalEdit();
    }

    const handleNameChange = (e) => {
        setNombre(e.target.value);
    }

    const handleIdChange = (e) => {
        setProdId(e.target.value);
    }

    const handleDescriptionChange = (e) => {
        setDescription(e.target.value);
    }

    return(
        <React.Fragment>
            <Modal title="Editar Producto" 
            visible={props.modalVisibleEdit}
            onOk={handleOk}
            onCancel={handleCancel}
            footer={[
                <Button key="back" onClick={handleCancel}>
                  Cancelar
                </Button>,
                <Button key="submit" type="primary" onClick={handleOk}>
                  Guardar
                </Button>
              ]}>
                <Row>
                    <Col span={24}>
                        <Input value={prodId} onChange={handleIdChange} placeholder="Id" maxLength="15" disabled/>
                    </Col>
                    <Col span={24}>
                        <br/>
                    </Col>
                    <Col span={24}>
                        <Input value={nombre} onChange={handleNameChange} placeholder="Nombre" />
                    </Col>
                    <Col span={24}>
                        <br/>
                    </Col>
                    <Col span={24}>
                        <Input value={description} onChange={handleDescriptionChange} placeholder="Descripción" />
                    </Col>
                    <Col span={24}>
                        <br/>
                    </Col>
                </Row>
            </Modal>

        </React.Fragment>
    )
}

export default ProductModalEdit;



// WEBPACK FOOTER //
// ./src/components/ProductModalEdit.jsx